const urlName = '/usercenter/v1'
export default API => ({
    getBanner() {
        return API({ url: '/banner' });
    },
    getTemplate() {
        return API({ url: '/templates' });
    },
    getSaasFindByCondition({ params, data }) {
        return API({ url: `${urlName}/saas/findByCondition`, params, data });
    },
    postSaasSave({ params, data }) {
        return API({ url: `${urlName}/saas/save`, method:'post', params, data });
    },
    postSaasFindById({ params, data }){
        return API({ url: `${urlName}/saas/findById`, method:'post', params, data });
    },
    postSaasDelete({ params, data }){
        return API({ url: `${urlName}/saas/delete`, method:'post', params, data });
    },
    // 分校管理列表
    getBranchList() {
        return API({
            url: `${urlName}/branch/getTree` ,
            method:  'get',
        });
    },
    // 删除分校
    postBranchDelete({ params, data }) {
        return API({
            url: `${urlName}/branch/delete` ,
            method:  'post',
            params, data
        });
    },
    // 编辑\新建分校
    postBranchSave({ data }) {
        return API({
            url: `${urlName}/branch/save` ,
            method:  'post',
            data
        });
    },
    // 获取指定分校
    postBranchFindById({params, data}) {
        return API({
            url: `${urlName}/branch/findById`,
            params,
            data
        });
    },
    // 部门管理
    getDepartList(data,pageNum,pageSize) {
        return API({
            url: `${urlName}/department/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'get',
            data
        });
    },
    getDepartDetail(id){
        return API({
            url: `${urlName}/branch/findById?id=${id}` ,
            method:  'get',
        });
    },
    getDepartTree(data) {
        return API({
            url: `${urlName}/department/getTree` ,
            method:  'get',
            data
        });
    },
    // 创建分校
    createBranch({data}){
        return API({
            url: `${urlName}/branch/save` ,
            method:  'post',
            data
        });
    },
    addDepart(data){
        return API({
            url: `${urlName}/department/save` ,
            method:  'post',
            data
        });
    },
    deleteDepart(id){
        return API({
            url: `${urlName}/department/delete?id=${id}` ,
            method:  'post',
        });
    },
})




